import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface TimelineStatusWrapperProps {
  maxHeight?: number
}

export const TimelineStatusWrapper = styled.div<TimelineStatusWrapperProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  ${({ maxHeight }) => maxHeight && `max-height: ${maxHeight}px;`}
  padding: ${Spacing.S16};
  border: 1px solid ${Color.Grey200};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.White};
`

export const Header = styled.header`
  display: flex;
  align-items: center;
  margin-bottom: ${Spacing.S16};
`

export const ContentWrapper = styled.div`
  & + ${() => ListWrapper} {
    margin-top: ${Spacing.S16};
  }
`

export const ListWrapper = styled.div`
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 24px;
    background-color: ${Color.Grey150};
    cursor: pointer;
  }

  &:hover {
    ::-webkit-scrollbar-thumb {
      background-color: ${Color.Grey200};
    }
  }
`

export const ExpansionTriggerWrapper = styled.div`
  padding: ${Spacing.S8};
  cursor: pointer;
  user-select: none;
`

export const ExpansionTriggerIconWrapper = styled.figure``
